import { heroTicker } from "@/mocks/critter";

const heroImage =
  "https://readdy.ai/api/search-image?query=editorial%20magazine%20collage%20of%20newspaper%20clippings%20magnifying%20glass%20and%20handshake%20over%20warm%20paper%20background%2C%20vermillion%20red%20and%20amber%20ink%20accents%2C%20layered%20transparency%2C%20sophisticated%20investigative%20journalism%20cover%20art&width=900&height=1000&seq=hero-cover&orientation=portrait";

export default function Hero() {
  const today = new Date().toLocaleDateString("zh-CN", {
    year: "numeric",
    month: "long",
    day: "numeric",
    weekday: "long",
  });

  return (
    <section id="top" className="relative overflow-hidden">
      <div className="mx-auto grid max-w-7xl grid-cols-1 items-center gap-10 px-4 md:px-6 pt-10 pb-14 lg:grid-cols-[1.05fr_0.95fr] lg:pt-16">
        {/* left copy */}
        <div className="fade-up">
          <div className="flex flex-wrap items-center gap-2 text-[11px]">
            <span className="rounded-full bg-primary-100 px-3 py-1 font-medium text-primary-700">
              <i className="ri-flashlight-fill mr-1"></i>今日头条
            </span>
            <span className="font-label text-foreground-500 tracking-wide">{today}</span>
          </div>

          <h1 className="mt-5 font-heading text-[32px] leading-[1.2] font-black text-foreground-950 md:text-5xl">
            呱呱爆料
            <span className="block text-[22px] md:text-[28px] font-bold text-primary-600 mt-2">
              穿透行业迷雾，看清利益链条背后的真实驱动
            </span>
          </h1>

          <p className="mt-5 max-w-xl text-[15px] leading-relaxed text-foreground-600">
            从行业黑幕到圈内潜规则，从资本操作到幕后推手——我们不做情绪化的标题党，只用
            证据、来源与因果链，把复杂的商业运作拆解成你看得懂、用得上的判断。每周为你
            更新深度专题、消费风险与反套路指南。
          </p>

          <div className="mt-7 flex flex-col gap-3 sm:flex-row sm:items-center">
            <a
              href="#reports"
              className="inline-flex items-center justify-center gap-2 rounded-md bg-primary-600 px-6 py-3 text-sm font-semibold text-background-50 hover:bg-primary-700 transition-colors whitespace-nowrap"
            >
              浏览最新深读
              <i className="ri-arrow-down-line"></i>
            </a>
            <a
              href="#deep"
              className="inline-flex items-center justify-center gap-2 rounded-md border border-foreground-900 px-6 py-3 text-sm font-semibold text-foreground-900 hover:bg-foreground-950 hover:text-background-50 transition-colors whitespace-nowrap"
            >
              阅读本期专题
            </a>
          </div>

          <dl className="mt-9 grid max-w-lg grid-cols-3 gap-4 border-t border-dashed border-foreground-300 pt-5">
            {[
              { v: "23", l: "深度专题" },
              { v: "560+", l: "原创专栏" },
              { v: "120w", l: "月度读者" },
            ].map((s) => (
              <div key={s.l}>
                <dt className="font-label text-xl font-bold text-accent-600 md:text-2xl">{s.v}</dt>
                <dd className="mt-1 text-xs text-foreground-500">{s.l}</dd>
              </div>
            ))}
          </dl>
        </div>

        {/* right cover */}
        <div className="relative hidden lg:block">
          <div className="absolute -left-8 top-8 h-40 w-40 rounded-full bg-accent-200/60 blur-2xl"></div>
          <div className="relative rounded-lg overflow-hidden border border-background-300">
            <img
              src={heroImage}
              alt="呱呱爆料编辑部调查报道主视觉"
              className="h-[520px] w-full object-top object-cover"
            />
            <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-foreground-950/85 to-transparent px-5 pb-4 pt-16">
              <p className="font-label text-[10px] uppercase tracking-[0.2em] text-accent-300">本期话题</p>
              <p className="mt-1 font-heading text-lg font-bold text-background-50">
                『全网最低价』到底便宜了谁？
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* ticker */}
      <div className="border-y border-background-300 bg-foreground-950 py-2.5 overflow-hidden">
        <div className="ticker-track">
          {[...heroTicker, ...heroTicker].map((t, i) => (
            <span key={i} className="mx-6 flex items-center gap-2 text-sm text-background-100">
              <i className="ri-megaphone-fill text-primary-400 text-xs"></i>
              {t}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}